export function isCredentialExpiredError (error) {
  const code = error && (error.code || error.name)
  return [
    'SecurityTokenExpired',
    'InvalidAccessKeyId',
    'InvalidSecurityToken',
    'AccessKeyIdAndSecurityTokenNotMatch'
  ].includes(code)
}

export function createRefreshingOssRunner ({ createClient, initialToken, refreshToken }) {
  let client = createClient(initialToken)
  let refreshPromise = null

  async function refreshClient () {
    if (!refreshPromise) {
      refreshPromise = refreshToken().then(freshToken => {
        client = createClient(freshToken)
        return client
      }).finally(() => {
        refreshPromise = null
      })
    }
    return refreshPromise
  }

  return {
    getClient: () => client,
    async run (operation) {
      const operationClient = client
      try {
        return await operation(operationClient)
      } catch (error) {
        if (!isCredentialExpiredError(error)) {
          throw error
        }
        if (client !== operationClient) {
          return operation(client)
        }
        return operation(await refreshClient())
      }
    }
  }
}
